import { isAfter, isBefore, isSameDay, isValid } from 'date-fns';

import { Row } from '../../../../../coaching-observation/experimental.grid';
import { CellContext, RowContext } from '../commitment-narrative.model';

export function filterRowsByDateRange(
    dateRange: { from: Date; to: Date } | null,
    rows: Array<Row<RowContext, CellContext>>,
): Array<Row<RowContext, CellContext>> {
    if (
        dateRange == null ||
        !isValid(dateRange.from) ||
        !isValid(dateRange.to)
    ) {
        return [...rows];
    }

    return rows.filter((row) => {
        const rowDate = new Date(row.ctx?.date ?? new Date());
        const fromDate = dateRange.from;
        const toDate = dateRange.to;

        return (
            isSameDay(rowDate, fromDate) ||
            isSameDay(rowDate, toDate) ||
            (isAfter(rowDate, fromDate) && isBefore(rowDate, toDate))
        );
    });
}
